import styled from 'styled-components';

const BgShadow = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	background: linear-gradient(90deg, #111314 0%, rgba(17, 19, 20, 0) 100%);
	width: 900px;
	height: 100%;
`;

export { BgShadow };
